import { TTableColumns } from '@/components/table/types/index';
import {
  extrudeArrayFromArray,
  getObjectFromArray,
  serializeDataByParams,
} from '@/helpers/dataHelpers';
import { TSelectedFilterValues } from '@/components/table/types';
import { TDictionary } from '@/types';

export default class ReportBuilderService {
  static changeActiveMetrics(
    columns: TTableColumns,
    metricValues: TSelectedFilterValues,
    dimentionValues: TSelectedFilterValues
  ): TTableColumns {
    const newColumns = [] as TTableColumns;

    try {
      const metricFields = serializeDataByParams(metricValues, 'value');

      if (dimentionValues.length) {
        newColumns.push(columns[0]);
        columns.shift();
      }

      for (const column of columns) {
        if (metricFields[column.field]) {
          column.visible = true;
        } else {
          column.visible = false;
        }

        newColumns.push(column);
      }
    } catch (err) {
      console.error('changeActiveMetrics: ', err);
    }

    return newColumns;
  }

  static changeDimensionMetric(
    columns: TTableColumns,
    dimensions: TTableColumns,
    dimensionValues: TSelectedFilterValues
  ): TTableColumns {
    const newColumns = [] as TTableColumns;
    const dimensionItems = [] as Array<TDictionary<string>>;

    try {
      for (const column of dimensions) {
        if (column.items?.length) {
          for (const item of column.items) {
            dimensionItems.push({
              field: String(item.value),
            });
          }
        }
      }

      const updateCoumns = extrudeArrayFromArray(
        columns,
        dimensionItems,
        'field'
      );

      if (dimensionValues.length) {
        const { field, label, value } = dimensionValues[0];

        const dimensionColumn = getObjectFromArray(dimensions, 'field', field);
        dimensionColumn.name = label;
        dimensionColumn.field = value;
        newColumns.push(dimensionColumn);
      }

      for (const column of updateCoumns) {
        newColumns.push(column);
      }
    } catch (err) {
      console.error('changeDimensionMetric: ', err);
    }

    return newColumns;
  }
}
